import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { ServiceIcon, SectionHeading, CTABand } from "@/components/blocks";
import { api } from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <SEO title="Services | Dr. Mithee's Clinic for Women, Noida" path="/services" description="Obstetrics, gynaecology, pregnancy care, menstrual & hormonal health, preventive care and menopause support at Dr. Mithee's Clinic for Women, Noida." />

      <section className="bg-gradient-to-b from-blush to-background pt-28 text-center md:pt-36">
        <div className="container-clinic pb-16">
          <Reveal><SectionHeading center overline="Our Services" title="Care shaped around every woman" subtitle="Thoughtful care categories consistent with a specialist obstetric and gynaecological practice." /></Reveal>
        </div>
      </section>

      <section className="container-clinic py-16 md:py-24">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 100}>
              <div className="group flex h-full flex-col rounded-3xl border border-soft-border bg-cream p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-card">
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-blush text-terracotta transition-colors group-hover:bg-terracotta group-hover:text-cream">
                  <ServiceIcon name={s.icon} />
                </span>
                <h3 className="mt-6 font-serif text-xl text-charcoal">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-taupe">{s.description}</p>
                <div className="mt-6 flex items-center justify-between">
                  <Link to="/appointment" className="inline-flex items-center gap-1.5 text-sm font-semibold text-terracotta link-underline">
                    Book Consultation <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
